/* @patrol-fixer:title-promotion */
(() => {
  // src/marker-fixes/watchMarkedElements.ts
  function watchMarkedElements(selector, managedAttribute, attach) {
    const attachOnce = (element) => {
      if (element instanceof HTMLElement && !element.hasAttribute(managedAttribute)) {
        element.setAttribute(managedAttribute, "");
        attach(element);
      }
    };
    const attachWithin = (root) => {
      if (root.matches(selector)) {
        attachOnce(root);
      }
      for (const element of root.querySelectorAll(selector)) {
        attachOnce(element);
      }
    };
    attachWithin(document.documentElement);
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node instanceof Element) {
            attachWithin(node);
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // src/marker-fixes/titlePromotionFix.ts
  var TITLE_PROMOTION_MARKER = "\u2060";
  function attachTitlePromotion(element) {
    const title = element.getAttribute("title");
    if (title === null || title[0] !== TITLE_PROMOTION_MARKER) {
      return;
    }
    element.setAttribute("aria-label", title.slice(1));
    element.removeAttribute("title");
  }
  var titlePromotionFix = {
    id: "title-promotion",
    start: () => watchMarkedElements(
      `a[title^="${TITLE_PROMOTION_MARKER}"]`,
      "data-patrol-title-managed",
      attachTitlePromotion
    )
  };

  // <stdin>
  titlePromotionFix.start();
})();
/* @end-patrol-fixer:title-promotion */